export var apiPath="/v1/certificates";var actionType="ASSETS";export var bulkActionType="".concat(actionType,"_BULK");export default actionType;